'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
require("slick-carousel");
var Pride;
(function (Pride) {
    var MyPride = /** @class */ (function () {
        function MyPride() {
            var self = this;
            self.changePrideHeight();
            window.addEventListener('resize', function () {
                self.changePrideHeight();
            });
        }
        // アニメーションの切り替え
        MyPride.prototype.changePrideHeight = function () {
            var windowHeight = Number($(window).outerHeight());
            var headerHeight = Number($('.paramHeaderContent').outerHeight());
            var prideHeight = windowHeight - headerHeight;
            $('.bulletPrideTop').css('height', prideHeight);
        };
        return MyPride;
    }());
    Pride.MyPride = MyPride;
})(Pride || (Pride = {}));
exports.default = Pride;
